import merge from 'deepmerge';
import { combineReducers } from 'redux';

const loans = () => (
  state = {
    // inital states here
    loansData: null,
    createdLoan: null,
  },
  action,
) => {
  if (action.type === 'LOANS_SUCCESS' && action.response.entities) { // maybe add switch case
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
  if (action.type === 'CREATE_LOAN_SUCCESS' && action.response.entities) {
    return {
      ...state,
      createdLoan: action.response.entities,
    };
  }

  return state;
};

export default combineReducers({
  loans: loans(),
});
